import React from 'react';
import ProjectionsList from '../components/ProjectionsList';

const ProjectionsListPage = () => {
  return <ProjectionsList isPomList={false} />;
};

export default ProjectionsListPage;